// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__widgetContainer {
  border: 2px solid var(--colors-yuzu-greyLight);
  overflow: hidden;
  border-radius: 7px;
}

.app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__card {
  height: 100%;
}

.app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__cardHeader {
  background-color: var(--colors-yuzu-greyLight);
  color: white;
  padding: 5px 10px !important;
  cursor: move;
}

.app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__cardHeader .app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__title {
    display: flex;
    align-items: center;
  }

.app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__iconBtn {
  color: white !important;
  font-size: 17px !important;
  margin-right: 5px !important;
  margin-top: 3px !important;
}

.app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__blur {
  filter: blur(3px);
  transition: filter 0.3s ease-in;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/ProductionManagement/Dashboards/DashboardWidgets/styles.scss"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,4BAA4B;EAC5B,YAAY;AAMd;;AAJE;IACE,aAAa;IACb,mBAAmB;EACrB;;AAGF;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,oBAAoB;AACtB","sourcesContent":[".widgetContainer {\n  border: 2px solid var(--colors-yuzu-greyLight);\n  overflow: hidden;\n  border-radius: 7px;\n}\n\n.card {\n  height: 100%;\n}\n\n.cardHeader {\n  background-color: var(--colors-yuzu-greyLight);\n  color: white;\n  padding: 5px 10px !important;\n  cursor: move;\n\n  & .title {\n    display: flex;\n    align-items: center;\n  }\n}\n\n.iconBtn {\n  color: white !important;\n  font-size: 17px !important;\n  margin-right: 5px !important;\n  margin-top: 3px !important;\n}\n\n.blur {\n  filter: blur(3px);\n  transition: filter 0.3s ease-in;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"widgetContainer": `app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__widgetContainer`,
	"card": `app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__card`,
	"cardHeader": `app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__cardHeader`,
	"title": `app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__title`,
	"iconBtn": `app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__iconBtn`,
	"blur": `app-pages-Project-ProductionManagement-Dashboards-DashboardWidgets-___styles__blur`
};
export default ___CSS_LOADER_EXPORT___;
